import request from "./request";

//查询权限分配时查看
const getProductAdvertisers = (data) => request("/bi/getProductAdvertisers", data, "GET");

//查看权限带分页
const queryProductPermission = (data) => request("/bi/queryProductPermission", data, "GET");

//分配权限
const grantProductPermission = (data) => request("/bi/grantProductPermission", data, "POST");

export default {
  getProductAdvertisers,
  queryProductPermission,
  grantProductPermission
}
